import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SpainGuard  {
    constructor(private router: Router) {}

    canActivate(next: ActivatedRouteSnapshot): boolean {
        if (environment.spain) {
            return true;
        }

        return false;
    }
}
